<body>
    <div id="studentProfile">
        <div class="Firstcontainer">
            <span class="" id="imgContainer">
                <img src="../../../../assets/image/studentProfile.png" alt=""></span>
            <span class="MainstudentDetails">
                <span>
                    <h3>Student Name :</h3>
                    <h4 id="studentName"></h4>
                </span>
                <span>
                    <h3>Admission Number :</h3>
                    <h4 id="admissionNumber"></h4>
                </span>
            </span>
        </div>
        <div class="secondcontainer studentDetails">
            <span>
                <h3>Parent Name :</h3>
                <h4 id="parentName"></h4>
            </span>
            <span>
                <h3>Study class :</h3>
                <h4 id="studyclass"></h4>
            </span>

        </div>
        <div class="secondcontainer studentDetails">
            <span>
                <h3>Section :</h3>
                <h4 id="section"></h4>
            </span>
            <span>
                <h3>Program Course :</h3>
                <h4 id="Course"></h4>
            </span>
        </div>
    </div>
    <div>
        <app-progress-report-page #progressReportPage></app-progress-report-page>
    </div>

    <!-- ================================ loader ======================-->
    <ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
        <p style="font-size: 20px; color: white">Loading...</p>
    </ngx-spinner>

</body>